import { escapeHtml, glyph } from "../lib/util.js";
import { searchItems } from "../lib/search.js";
import { state } from "../lib/state.js";
import { navigate } from "../lib/router.js";

export function renderHomeResults(els) {
  const query = els.searchInput.value;
  state.query = query;
  const q = query.trim();

  if (!q) {
    els.results.innerHTML = "";
    els.heroTagline.hidden = false;
    return;
  }

  els.heroTagline.hidden = true;
  const matches = searchItems(q);
  if (!matches.length) {
    els.results.innerHTML = `<li class="empty">No matches for “${escapeHtml(q)}”.</li>`;
    return;
  }

  els.results.innerHTML = matches
    .map(
      (item, i) => `
      <li style="animation-delay:${Math.min(i, 12) * 20}ms">
        <button type="button" class="result" data-slug="${escapeHtml(item.slug)}">
          ${glyph(item.name, item.colour)}
          <span class="result-text">
            <span class="result-name">${escapeHtml(item.name)}</span>
            <span class="result-meta">${escapeHtml(item.group || item.catalogue || "")}</span>
          </span>
          <span class="result-kinds">${escapeHtml((item.kinds || []).join(" · "))}</span>
        </button>
      </li>`
    )
    .join("");
}

export function bindHome(els) {
  els.searchForm.addEventListener("submit", (e) => {
    e.preventDefault();
    renderHomeResults(els);
  });
  els.searchInput.addEventListener("input", () => renderHomeResults(els));
  els.results.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-slug]");
    if (!btn) return;
    navigate("item", btn.dataset.slug);
  });
}

export function setupInstallHint(els) {
  if (!els.installHint || !els.installText) return;
  const ua = navigator.userAgent || "";
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  if (isStandalone) {
    els.installHint.hidden = true;
    return;
  }

  els.installHint.hidden = false;
  if (isIOS) {
    els.installText.innerHTML = `<span class="install-label">iPhone / iPad</span><span class="install-steps">Safari → Share → <strong class="install-action">Add to Home Screen</strong></span>`;
  } else if (isAndroid) {
    els.installText.innerHTML = `<span class="install-label">Android</span><span class="install-steps">Chrome menu → <strong class="install-action">Install app</strong></span>`;
  } else {
    els.installText.innerHTML = `<span class="install-label">Install</span><span class="install-steps">Use your browser menu, or <strong class="install-action">Add to Home Screen</strong> on a phone</span>`;
  }

  let deferred = null;
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferred = event;
    if (els.installBtn) els.installBtn.hidden = false;
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    els.installHint.hidden = true;
  });
  els.installBtn?.addEventListener("click", async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch {
      /* ignore */
    }
    deferred = null;
    els.installBtn.hidden = true;
  });
}
